import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    brandsHeading:{
        color:'#fe6b02',
        marginLeft:'4vw',
        fontWeight:'700',
        fontSize:'1.8rem',
        fontFamily:'Helvetica'
    },
    brandCarousel:{
        margin:'6vh 2vw',
        padding:'0vh 4vw',
    }
}));

export default useStyles;